export default class EvidenceStatus {
  static Pending = 0;
  static Unapproved = 1;
  static Verified = 2;
}
